import React from 'react';
import StudentForm from './components/StudentForm';

const App: React.FC = () => {
  return (
    <div
      className="h-full overflow-y-auto w-full"
      data-parent-application-scroll-root="true"
    >
        <StudentForm />
    </div>
  );
};

export default App;